"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "Wat onderscheidt jullie werkwijze van andere bureaus?",
  answer: "Genoeg bureaus die mooie praatjes verkopen en daarna verdwijnen. Wij niet. Wij geloven dat AI pas waarde heeft als er een mens achter zit die jouw naam kent, jouw verhaal begrijpt en meedenkt. Geen standaard pakketjes. Gewoon doen wat we zeggen."
}, {
  question: "Hoe helpt AI mijn marketingstrategie concreet?",
  answer: "AI doet het denkwerk dat jou uren kost in minuten. Slimmere advertenties, betere inzichten, geautomatiseerde opvolging. Zodat jij stopt met brandjes blussen en begint met bouwen aan wat groei brengt. Jouw klanten, jouw ambities, jouw tijd."
}, {
  question: "Hoe maken jullie de resultaten van marketing inzichtelijk?",
  answer: "Geen dashboards vol cijfers waar je zelf maar chocola van moet maken. Wij houden je proactief op de hoogte, in begrijpelijke taal, en laten je zien wat werkt en waar kansen liggen. Transparantie is geen buzzword bij ons, het is hoe we werken."
}, {
  question: "Wat is het directe voordeel van een AI-gedreven klantenservice?",
  answer: "Jouw klantenservice staat klaar terwijl jij slaapt, op vakantie bent of gewoon lekker bezig bent met je klanten. Vragen beantwoord, leads gekwalificeerd, afspraken ingepland. Zonder extra handen, zonder extra kosten. Tijdswinst die je direct voelt."
}, {
  question: "Zijn jullie diensten geschikt voor startende ondernemers?",
  answer: "Absoluut. Sterker nog, juist als starter is de juiste digitale fundering het verschil tussen groeien en stilstaan. Wij kijken samen waar de meeste impact zit voor jouw situatie. Geen overkill, geen dure pakketten. Gewoon wat werkt voor jou, nu."
}];
export default function FrequentlyAskedQuestions() {
  return <section data-section-id="146494" id="veelgestelde-vragen" className="text-foreground py-16 !bg-[hsl(20,100%,98%)] md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-[800px]">
          <div className="mb-12 text-center">
            <h2 className="text-foreground mb-4 text-3xl font-bold tracking-tight sm:text-5xl font-default">FAQ</h2>
            <p className="text-muted-foreground text-lg sm:text-xl font-sans leading-relaxed">Goede vraag is het halve antwoord. Wij krijgen ze veel, dus zetten we de meest gestelde hieronder op een rij. Staat jouw vraag er niet tussen? Stuur ons gewoon een bericht.</p>
          </div>

          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/50 py-4 transition-all duration-300">
                <AccordionTrigger className="text-foreground text-left text-lg font-bold hover:no-underline sm:text-xl font-default hover:text-accent-foreground transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed sm:text-lg font-sans pt-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}